<template>
  <md-layout class='exp-layout'>
  
    <md-layout md-flex="10"></md-layout>
    <md-layout  md-column  md-align="center" class="l_experiment">
    
    <router-link to="/">
      <img src='../assets/chemistryAI_logo.png' style="height: 7%;  position:absolute; top:2%;"/>
    </router-link>  
    <span v-if="experiment_type === 2 && emotive_device == ''" class="emo_state_device">
      <md-progress md-indeterminate></md-progress>
    </span> 
    <div v-if="experiment_type === 2 && !loaded">
      <center>
        <span class="md-display-1 fade-in">
          Please connect Emotiv Epoc+ to start the Experiment.
        </span>
      </center>
    </div>

    <div v-else-if="!loaded">
      <center>
         <span class="md-display-1 fade-in">
          loading ...
         </span>
      </center>
    </div>
    
    <div v-for="(molecule, index) in mols" style="height:100%;" v-bind:key="index" v-show="loaded && index === moleculeIndex">
      <div v-show="index === moleculeIndex" style="height:100%;">
         <img :src="'/static/mol/'+molecule.name+'.png'" class="fade-in-fast" style="height:90%; border-radius: 25px; flex: 1"/>
       
       <div>
        <div v-if="show_emo_state && experiment_type === 2" class="emo_state">
          <p v-if="emotive_device == ''">
            <md-spinner :md-size="20" md-indeterminate class="md-accent"></md-spinner> waitng for device ...
          </p>
          <p v-else>
            {{ emotive_device }}
            <md-progress :md-progress="met.interest"></md-progress>
            <md-progress :md-progress="met.stress"></md-progress>
            <md-progress :md-progress="met.relaxation"></md-progress>
            <md-progress :md-progress="met.excitement"></md-progress>
            <md-progress :md-progress="met.engagement"></md-progress>
            <md-progress :md-progress="met.long_term_excitement"></md-progress>
            <md-progress :md-progress="met.focus"></md-progress>
          </p>
        </div>
       <center>
       
      <md-button v-if="experiment_type!=2" class="md-raised md-primary like_button" @click="rate(molecule.id, molecule.design, moleculeIndex,  0)">
        <span v-if="experiment_type==0">Like</span> 
                                <span v-else>Human</span> 
      </md-button>
      <md-button v-if="experiment_type!=2" class="md-raised md-warn dislike_button" @click="rate(molecule.id, molecule.design, moleculeIndex, 1)">
         <span v-if="experiment_type==0">Dislike</span>
                                <span v-else>GAN</span>
      </md-button>
      
       </center>
      </div>
     
      </div>
    </div>
     
     
    <md-layout v-if="false">
    
      <div v-show="moleculeIndex === mols.length">
        <h2>Done!</h2>
      <p v-if="experiment_type==0">
      results: Human Liked: {{humanLiked}}. GAN Liked: {{ganLiked}}
      </p>
      <p v-else>
      results: Right: {{guessedRight}}. Wrong: {{guessedWrong}}
      </p>
  
    
    </div>
    
    </md-layout>
    
    </md-layout>
    
    
    <md-layout md-flex="10"></md-layout>
  </md-layout>

</template>

<script>
import Cortex from '../lib/cortex'

var timerObj
var cortexClient
var onMet

var device_ready_timerObj
const cortex_api_auth = {
  username: 'insilico',
  password: 'emotivPass',
  client_id: 'XfQ1sX8m03qTilfr68vn7FEpJyDnTl6yklJkfozp',
  client_secret: 'GZvKlQAuuuotygVA0U3DbVDjoM6vd34Nz4i13grieeblM4GHG5tEfnTAzUfDT8e4tSosvgQ2qfkvJ1zGzucpkslXIMc8wcawNC4hS7TOOTipH9lx9qHreowN9tF5nxRD',
  debit: 1 // first time you run example debit should > 0
}
var data = []

export default {
  name: 'userform',
  props: ['experiment_type'],
  data () {
    return {
    	moleculeIndex: 0,
    	guessedRight: 0,
    	guessedWrong: 0,
    	ganLiked: 0,
      humanLiked: 0,
      emotive_device: '',
      met_int: 0,
      met: {
        interest: 0, 
        stress: 0,
        relaxation: 0,
        excitement: 0,
        engagement: 0,
        long_term_excitement: 0,
        focus: 0
      },
      show_emo_state: false,
      loaded: false
      }
  },
  beforeCreate() {
		
		
  },
  created() {
	this.$store.dispatch('addExperiment', {'exp_type': this.experiment_type, 'user': this.currentUser.pk })
    this.$store.dispatch('getMolecules')
      .then(() => {
    if (this.experiment_type == 2 ) {
      cortexClient = cortexClient || new Cortex()
      console.log('Waiting for device')
      cortexClient.ready
        .then(() => cortexClient.init(cortex_api_auth))
        .then(() => new Promise(function(resolve, reject) {
          var hs = null
          device_ready_timerObj = window.setInterval(function () {
            console.log('Checking device')
            hs = cortexClient.queryHeadsets()
          }, 500);
          setTimeout(function () {
            window.clearTimeout(device_ready_timerObj)
            device_ready_timerObj = null
            resolve(hs)
          }, 2500)
          }))
        .then((hs) => {
          if (hs.length != 0) {
            //console.log('Headsets: ' + JSON.stringify(hs))
            /* Headsets: [
              {"connectedBy":"dongle",
              "dongle":"6ff",
              "firmware":"611",
              "id":"EPOCPLUS-3B9AD892",
              "label":"",
              "sensors":[],
              "settings":{"eegRate":128,"eegRes":14,"memsRate":0,"memsRes":0,"mode":"EPOC"},
              "status":"connected"}] */
              this.loaded = true
            // console.log('Set device to first available: ' + hs[0].id)
            this.emotive_device = hs[0].id
            // console.info('Creating session for this device')
            // console.log(' AUTH:  ' + JSON.stringify(cortexClient._auth))
            
            cortexClient
              .createSession({
                _auth: cortexClient._auth,
                status: 'active', 
                headset: hs[0].id
                })
              .then(() => cortexClient.subscribe({streams: ['met']}))
              .then(subs => {
                console.log('Subscribed to' + JSON.stringify(subs))
                if (!subs[0].met) throw new Error('failed to subscribe')
                  onMet = (ev) => {
                  console.log('MET: ' + ev.met)
                  data.push(ev.met)
                  this.met.interest = ev.met[0] * 100
                  this.met.stress = ev.met[1] * 100
                  this.met.relaxation = ev.met[2] * 100
                  this.met.excitement = ev.met[3] * 100
                  this.met.engagement = ev.met[4] * 100
                  this.met.long_term_excitement = ev.met[5] * 100
                  this.met.focus = ev.met[6] * 100
                }
                cortexClient.on('met', onMet)
                })
              .then(() => this.startTimer())
          
          } else {
            console.log('Could not start Experiment without headset connected')
          }})
    } else {
        this.loaded = true
		this.startTimer()
    }
    })
  },
  computed: {
	mols() { 
    return this.$store.state.molecules;
	},
	isAuth(){
		return this.$store.getters.isLoggedIn
	},
	currentUser(){
		return this.$store.getters.getUser
	}
  },
  watch: {
	  moleculeIndex: function(){
		  this.stopTimer()
		  if(this.moleculeIndex < (this.mols.length)) {
        this.startTimer()
        if (this.experiment_type == 2) {
          this.record_eeg()
        }
      } else this.$router.push({name: 'experiment_result',  params: { 'id': this.$store.state.experiment.id }});
  }},
  methods: {
	 rate: function(mollId, molDesign, moleculeIndex, reaction){

		 if(this.experiment_type ==1) {
		   if(molDesign==reaction) {
		                        this.guessedRight++
                            this.mols[moleculeIndex].guess = 1
		                         }
		   else {
		     this.guessedWrong++
		     this.mols[moleculeIndex].guess = 0
		   }
		 }
		 else{
		   if(reaction==0) this.mols[moleculeIndex].guess = 1	
		   if(reaction==1) this.mols[moleculeIndex].guess = 0
		 }
		 
		 this.$store.dispatch('rateMolecule', {'molecule': mollId, 'reaction': reaction })
		 this.moleculeIndex++;
	 },   
	 startTimer(){
         timerObj = window.setInterval(this.timerTick, 5000);
         
     },
     stopTimer(){
         window.clearInterval(timerObj);
         timerObj = null;
     },
     timerTick(){
    	 this.moleculeIndex++;
     },
    connect_to_device () {
      
    },
    get_average_data() {
      var averages = []

      data.forEach((col, _i) => {
        col.forEach((e,i) =>
          averages[i] = averages[i] === undefined ? col[i] : averages[i] + col[i])
        })

      averages.forEach((col, i) => 
        averages[i] = averages[i]/data.length)
      return averages
    },
    record_eeg() {
      const molecule = this.mols[this.moleculeIndex]
      console.info('Recording DATA for molecule #: ' + this.moleculeIndex)
      console.info(JSON.stringify(molecule))
      console.log(data)
      const avgs = this.get_average_data()

      // int interest value
      // str stress value
      // rel relaxation value
      // exc excitement value
      // eng engagement value
      // lex long term excitement value
      // foc focus value

      const reaction = avgs[0].toFixed() // using only Interest value
      
      console.log("Computed Reaction: " + reaction)
      this.mols[this.moleculeIndex].data = avgs
      console.log("Human interest value on molecule: " + JSON.stringify(this.mols[this.moleculeIndex]) + "| EXC: " + this.mols[this.moleculeIndex].eeg_int)
      
      const guessed = reaction => reaction === this.mols[this.moleculeIndex].design
      switch (guessed(reaction)) {
        case true:
          this.mols[this.moleculeIndex].guess = 1
        case false:
          this.mols[this.moleculeIndex].guess = 0
      }
      
      this.$store.dispatch(
        'rateMolecule', {
          'molecule': molecule.id,
          'reaction': reaction,
          'rawdata': data,
          'data': avgs
          })
      data = []
    }
    },
    beforeDestroy () {
      this.stopTimer()
      if (this.experiment_type == 2){
     cortexClient
      .unsubscribe({streams: ['met']})
      .then(() => cortexClient.updateSession({status: 'close'}))
          .then(() => cortexClient.removeListener('met', onMet))
      .then(() => cortexClient.close())
        cortexClient = null
      }
     
  }
}
</script>

<style scoped>

.exp-layout {
    height:100%;
    width: 100%;
    position: relative;
    background-image:    url(../assets/experiment_back.png);
    background-size:     cover;                      
    background-repeat:   no-repeat;
    background-position: center center;              
}

.md-boards-navigation {
  display: none !important;
}
.l_experiment {

    background-color: #fff;
    margin: 5vw 0;
    padding: 0;
    border-radius: 25px;
    
}
.like_button {
    font-size: 2vw;
    padding: 5px; 
    border-radius: 5px;
    color: #fff !important;
    width: 20%;
    background-color: #6faa43 !important;
}
.dislike_button {
    font-size: 2vw;
    padding: 5px; 
    border-radius: 5px;
    width: 20%;
    background-color: #58b1df !important;
}
.emo_state_device {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
}

.fade-in {
	opacity: 1;
	animation-name: fadeInOpacity;
	animation-iteration-count: 1;
	animation-timing-function: ease-in;
	animation-duration: 3s;
}

.fade-in-fast {
	opacity: 1;
	animation-name: fadeInOpacity;
	animation-iteration-count: 1;
	animation-timing-function: ease-in;
	animation-duration: 0.2s;
}

@keyframes fadeInOpacity {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>



// WEBPACK FOOTER //
// Experiment.vue?9d65d348